module.exports = __webpack_public_path__ + "img/propulsion.07eedcd2.svg";